import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useMobileFilters } from 'shared/hooks/useMobileFilters';
import { selectMobileFiltersVisible } from 'shared/selectors/page/selectMobileFiltersVisible';
import { MyHomeFormContainer } from '../../MyHomeFormMicrofrontend';

export const FiltersMobileContainer: React.FC = () => {
  const { closeMobileFiltersModal } = useMobileFilters();
  const mobileFiltersVisible = useSelector(selectMobileFiltersVisible);

  return (
    <ModalWindow
      open={mobileFiltersVisible}
      onClose={closeMobileFiltersModal}
      title="Добавить объект в Мой дом"
      content={<MyHomeFormContainer />}
      width="100%"
      height="100%"
    />
  );
};

FiltersMobileContainer.displayName = 'FiltersMobileContainer';
